/**
 * Resuelve la base URL del backend con prioridad:
 *   1. process.env.REACT_APP_API_URL (si fue definida en build time)
 *   2. Detección por hostname (mismo origin del flow-frontend → flow-backend)
 *      - dev.gestdoc.cl    → https://dev.gestdoc.cl
 *      - flow.gestdoc.cl   → https://flow.gestdoc.cl
 *      - localhost (dev)   → http://localhost:5001
 *
 * Por qué existe este helper:
 * Hubo casos donde el build se hizo sin definir REACT_APP_API_URL y el
 * bundle quedó con `localhost:5001` hardcodeado, rompiendo el chat IA y
 * el extractor en `dev.gestdoc.cl` (CONNECTION_REFUSED a localhost del
 * visitante). Este fallback evita que ese error se repita.
 *
 * Uso:
 *   import API_URL from '../../utils/apiBaseUrl';
 *   fetch(`${API_URL}/api/chat`);
 */

function resolveApiBaseUrl() {
	// 1. Build-time env var tiene prioridad
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL;
	}

	// 2. Runtime hostname detection (solo en browser)
	if (typeof window !== 'undefined' && window.location) {
		const host = window.location.hostname;

		// Si estamos en cualquier subdominio de gestdoc.cl, el flow-backend
		// vive en el mismo origen — apuntamos al window.location.origin.
		if (host === 'dev.gestdoc.cl' || host === 'flow.gestdoc.cl' || host.endsWith('.gestdoc.cl')) {
			return window.location.origin;
		}
	}

	// 3. Default — desarrollo local (flow-backend en :5001 por convención)
	return 'http://localhost:5001';
}

const API_BASE_URL = resolveApiBaseUrl();

export default API_BASE_URL;
